var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center content-center justify-center p-40"},[_c('SegmentedControl',{attrs:{"tabs":_vm.tabs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }